<template>
  <v-container fluid>
    <!-- KPIs Dashboard -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #4CAF50' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Total Ventas</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ formatCurrency(kpiData.total_ventas || 0) }}
            </div>
            <div class="text-caption grey--text">
              {{ kpiData.total_documentos || 0 }} documentos
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #2196F3' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Efectivo</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ formatCurrency(kpiData.total_efectivo || 0) }}
            </div>
            <div class="text-caption grey--text">
              {{ kpiData.porcentaje_efectivo || 0 }}% del total
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #FF9800' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Electrónico</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ formatCurrency(kpiData.total_electronico || 0) }}
            </div>
            <div class="text-caption grey--text">
              {{ kpiData.porcentaje_electronico || 0 }}% del total
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #FF5252' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Ticket Promedio</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ formatCurrency(kpiData.ticket_promedio || 0) }}
            </div>
            <div class="text-caption grey--text">
              {{ kpiData.total_transacciones || 0 }} transacciones
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Barra de filtros -->
    <v-card class="mb-6" elevation="2">
      <v-app-bar flat dense color="secondary" dark>
        <v-toolbar-title>Reporte de Caja</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="issueDate"
          label="Fecha"
          hide-details="auto"
          required
          dense
          outlined
          type="date"
          :rules="f_required"
          class="mx-2"
          style="max-width: 180px"
          @input="get_report"
        />
        <v-btn icon color="white" @click="downloadExcel" title="Exportar a Excel">
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-app-bar>
    </v-card>

    <!-- <v-text-field
      v-model="issueDate"
      label="Fecha"
      hide-details="auto"
      required
      outlined
      type="date"
      :rules="f_required"
      dense
      prepend-icon="mdi-cash-register"
      append-outer-icon="mdi-magnify"
      @input="get_report"
      @click:append-outer="get_report"
    /> -->
    <v-row>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-title> Por tipo de Documento </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headersDocType"
              :items="docType"
              :items-per-page="10"
              item-key="id"
              sort-by="name"
              mobile-breakpoint="0"
              class="elevation-4"
              :loading="loading_status"
              loader-height="10"
              loading-text="Cargando ..."
              dense
            >
              <template #top> </template>
              <template v-slot:[`item.qty`]="{ item }">
                <span>{{ parseFloat(item.qty).toLocaleString("es") }}</span>
              </template>
              <template v-slot:[`item.value`]="{ item }">
                <span>{{ formatCurrency(parseFloat(item.value)) }}</span>
              </template>
              <template slot="body.append">
                <tr>
                  <th class="title">Total</th>
                  <th class="text-center">{{ sumTable("cash_type", "qty") }}</th>
                  <th class="text-right">{{ sumCurrency("cash_type", "value") }}</th>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-title>Por Vendedor</v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headersDocType"
              :items="Vendors"
              :items-per-page="10"
              item-key="id"
              sort-by="name"
              mobile-breakpoint="0"
              class="elevation-4"
              :loading="loading_status"
              loader-height="10"
              loading-text="Cargando ..."
              dense
            >
              <template #top> </template>
              <template v-slot:[`item.qty`]="{ item }">
                <span>{{ parseFloat(item.qty).toLocaleString("es") }}</span>
              </template>
              <template v-slot:[`item.value`]="{ item }">
                <span>{{ formatCurrency(parseFloat(item.value)) }}</span>
              </template>
              <template slot="body.append">
                <tr>
                  <th class="title">Total</th>
                  <th class="text-center">{{ sumTable("cash_type", "qty") }}</th>
                  <th class="text-right">{{ sumCurrency("cash_type", "value") }}</th>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="12">
        <v-card flat>
          <v-card-title> Formas de pago </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers_cash"
              :items="cash_type"
              :items-per-page="10"
              item-key="id"
              sort-by="name"
              mobile-breakpoint="0"
              class="elevation-4"
              :loading="loading_status"
              loader-height="10"
              loading-text="Cargando ..."
              dense
            >
              <template #top> </template>
              <template v-slot:[`item.qty`]="{ item }">
                <span>{{ parseFloat(item.qty).toLocaleString("es") }}</span>
              </template>
              <template v-slot:[`item.value`]="{ item }">
                <span>{{ formatCurrency(parseFloat(item.value)) }}</span>
              </template>
              <template slot="body.append">
                <tr>
                  <th class="title">Total</th>
                  <th class="text-center">{{ sumTable("cash_type", "qty") }}</th>
                  <th class="text-right">{{ sumCurrency("cash_type", "value") }}</th>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="d-none d-md-block">
      <v-data-table
        :headers="headers_docs"
        :items="cash_data"
        :items-per-page="10"
        mobile-breakpoint="0"
        item-key="id"
        sort-by="name"
        class="elevation-4 mt-6"
        :loading="loading_status_docs"
        loader-height="10"
        loading-text="Cargando ..."
        dense
        @click:row="get_e_doc"
      >
        <template #top>
          <v-toolbar flat>
            <b>Documentos</b>
            <v-spacer></v-spacer>
            <!-- <v-btn icon @click="downloadExcel"><v-icon>mdi-microsoft-excel</v-icon></v-btn> -->
          </v-toolbar>
        </template>

        <template v-slot:[`item.qty`]="{ item }">
          <span>{{ formatCurrency(parseFloat(item.qty)) }}</span>
        </template>
        <template v-slot:[`item.doc_value`]="{ item }">
          <span>{{ formatCurrency(parseFloat(item.doc_value)) }}</span>
        </template>
        <template v-slot:[`item.cufe`]="{ item }">
          <v-icon small class="mr-2" v-if="item.cufe"> mdi-check-all </v-icon>
        </template>
        <template v-slot:[`item.dian_id`]="{ item }">
          <v-icon small class="mr-2" v-if="item.dian_id"> mdi-check-all </v-icon>
        </template>
        <template v-slot:[`item.cufe_n`]="{ item }">
          <v-icon small class="mr-2" v-if="item.cufe_n"> mdi-check-all </v-icon>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="get_e_doc(item)"> mdi-magnify </v-icon>
        </template>
        <template slot="body.append"> </template>
      </v-data-table>
    </v-card>
    <v-card class="d-md-none">
      <v-card-title>
        <span>Documentos</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-list two-line>
        <v-list-item-group>
          <template v-for="(item, index) in cash_data">
            <v-list-item :key="item.id" @click="get_e_doc(item)" class="cursor-pointer">
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  {{ item.doc_number }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <span>{{ formatDate(item.issuedate) }}</span>
                  <span class="ml-2">{{ item.invoice }}</span>
                </v-list-item-subtitle>

                <div class="d-flex align-center mt-1">
                  <div v-if="item.cufe" class="mr-3">
                    <v-icon color="success" x-small>mdi-check-all</v-icon>
                    <span class="caption ml-1">CUFE</span>
                  </div>
                  <div v-if="item.cufe_n">
                    <v-icon color="success" x-small>mdi-check-all</v-icon>
                    <span class="caption ml-1">NC</span>
                  </div>
                </div>
              </v-list-item-content>
              <v-list-item-action>
                <span class="font-weight-bold">{{ formatCurrency(item.doc_value) }}</span>
              </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index < cash_data.length - 1"
              :key="'div-' + index"
            ></v-divider>
          </template>
        </v-list-item-group>
      </v-list>
    </v-card>
    <docViewer
      :item="item"
      :dialog="dialog"
      @close="dialog = false"
      @refresh="refresh()"
    />
  </v-container>
</template>

<script>
import { webserver, getToday, formatCurrency } from "@/services/webserver.js";
import docViewer from "../components/doc_viewer.vue";
import createDoc from "../utils/create_doc.js";
import * as XLSX from "xlsx";
// import { GChart } from "vue-google-charts";

export default {
  components: { docViewer },
  data() {
    return {
      kpiData: {
        total_ventas: 0,
        total_documentos: 0,
        total_efectivo: 0,
        porcentaje_efectivo: 0,
        total_electronico: 0,
        porcentaje_electronico: 0,
        ticket_promedio: 0,
        total_transacciones: 0,
      },
      f_required: [(v) => !!v || "Requerido"],
      loading_status: false,
      loading_status_docs: false,
      searchvalid: false,
      issueDate: getToday(),
      headers: [
        {
          text: "Documento ID",
          align: "start",
          sortable: true,
          value: "order_num",
          dataType: "text",
        },
        {
          text: "Cliente",
          align: "start",
          sortable: true,
          value: "client_name",
          dataType: "text",
        },
        {
          text: "Cantidad",
          align: "center",
          sortable: true,
          value: "quantity",
          dataType: "number",
        },
        {
          text: "Descuento",
          align: "end",
          sortable: true,
          value: "descuento",
          dataType: "number",
        },
        {
          text: "Valor",
          align: "end",
          sortable: true,
          value: "valor",
          dataType: "number",
        },

        { text: "", value: "actions", align: "end", sortable: false },
      ],
      headers_cash: [
        {
          text: "Forma de pago",
          align: "start",
          sortable: true,
          value: "label",
          dataType: "text",
        },
        {
          text: "Cantidad",
          align: "center",
          sortable: true,
          value: "qty",
          dataType: "number",
        },
        {
          text: "Valor",
          align: "end",
          sortable: true,
          value: "value",
          dataType: "number",
        },
      ],
      headersDocType: [
        {
          text: "Documento",
          align: "start",
          sortable: true,
          value: "label",
          dataType: "text",
          cellClass: "wrap-text", // Clase para celdas
          headerClass: "wrap-text", // Clase para el encabezado
        },
        {
          text: "Cantidad",
          align: "center",
          sortable: true,
          value: "qty",
          dataType: "number",
        },
        {
          text: "Valor",
          align: "end",
          sortable: true,
          value: "value",
          dataType: "number",
        },
      ],
      headers_docs: [
        {
          text: "Fecha",
          align: "start",
          sortable: true,
          value: "issuedate",
          dataType: "text",
        },
        {
          text: "Documento",
          align: "start",
          sortable: true,
          value: "doc_number",
          dataType: "text",
        },

        {
          text: "Factura",
          align: "start",
          sortable: true,
          value: "invoice",
          dataType: "text",
        },
        {
          text: "Valor",
          align: "end",
          sortable: true,
          value: "doc_value",
          dataType: "number",
        },
        {
          text: "CUFE",
          align: "end",
          sortable: true,
          value: "cufe",
        },
      ],
      cash_data: [],
      cash_type: [],
      docType: [],
      Vendors: [],
      dialog: false,
      item: createDoc(),
      chartPayments: ["Evento", "Cantidad"],
      chartOptions: {
        curveType: "function",
        legend: { position: "right" },
        interpolateNulls: true,
        crosshair: { trigger: "both", opacity: 0.95, color: "#39FF14" },
        title: "",
        isStacked: false,
        hAxis: {
          title: "",
          slantedText: true,
          slantedTextAngle: 15,
        },
        colors: ["#1b9e77", "#d95f02", "#7570b3"],
        height: 400,
      },
    };
  },
  mounted() {
    this.get_report();
  },
  methods: {
    formatCurrency,
    formatDate(dateString) {
      if (!dateString) return "";
      // Extraer solo la fecha sin la hora
      return dateString.split(" ")[0];
    },

    downloadExcel() {
      const ws = XLSX.utils.json_to_sheet(this.cash_data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "cash_data.xlsx");
    },
    sumTable(table, key) {
      // sum data in give key (property)
      return parseFloat(
        this[table].reduce((a, b) => a + (parseFloat(b[key]) || 0), 0)
      ).toLocaleString(2);
    },
    sumCurrency(table, key) {
      // sum data in give key (property)
      return formatCurrency(
        parseFloat(this[table].reduce((a, b) => a + (parseFloat(b[key]) || 0), 0))
      );
    },
    showInvoice(e) {
      this.loading_status = true;
      var qry = {
        store: window.store.store_id,
        dateTo: e.order_date,
        did: e.order_number,
      };
      webserver("get_invoice", qry, (data) => {
        //console.log(data);
        this.item = { ...data };
        this.dialog = true;
        this.loading_status = false;
      });
    },
    get_e_doc(e) {
      var issudate = e.issuedate.split(" ");
      console.log(issudate[0]);
      var doc = {
        store: e.store,
        issueDate: issudate[0],
        did: e.doc_number,
      };
      console.log(doc);
      webserver("get_invoice_fe", doc, (data) => {
        console.log(data);
        this.item = data;
        this.dialog = true;
        // data.doc.doc_type = "Invoice";
        this.loading_vendors = false;
      });
    },
    async get_report() {
      this.loading_status = true;
      try {
        var qry = {
          store: window.store.store_id,
          date: this.issueDate,
        };

        if (this.$store.getters.profile.user_access == "USUARIO") {
          qry.userId = this.$store.state.profile.email;
        }

        console.log(qry);

        let promise = new Promise((resolve, reject) => {
          webserver(
            "get_cashdrawer_report",
            qry,
            function (data) {
              resolve(data);
            },
            function () {
              reject([]);
            }
          );
        });

        let dat = await promise;
        // console.log("====>", dat);

        // Calcular KPIs
        this.calculateKPIs(dat.payments);
        let data = dat.payments;
        var result = [];
        var dtSet = [];
        dtSet.push(["Forma de pago", "Valor"]);
        dtSet.push(["", 0]);

        data.reduce(function (res, value) {
          if (!res[value.payment_concept]) {
            res[value.payment_concept] = {
              label: value.payment_concept,
              qty: 0,
              value: 0,
            };
            result.push(res[value.payment_concept]);
          }
          res[value.payment_concept].qty += 1;
          res[value.payment_concept].value += parseFloat(value.payment_value);
          return res;
        }, {});

        result.sort((a, b) => (a.value > b.value ? 1 : b.value > a.value ? -1 : 0));
        this.cash_type = result;

        var docTypes = [];
        data.reduce(function (res, value) {
          if (!res[value.doc_type]) {
            res[value.doc_type] = { label: value.doc_type, qty: 0, value: 0 };
            docTypes.push(res[value.doc_type]);
          }
          res[value.doc_type].qty += 1;
          res[value.doc_type].value += parseFloat(value.payment_value);
          return res;
        }, {});

        this.docType = docTypes;

        this.Vendors = [];
        result = [];
        data.reduce(function (res, value) {
          if (!res[value.userId]) {
            res[value.userId] = { label: value.userId, qty: 0, value: 0 };
            result.push(res[value.userId]);
          }
          res[value.userId].qty += 1;
          res[value.userId].value += parseFloat(value.payment_value);
          return res;
        }, {});
        this.Vendors = result;

        result.forEach((rg) => {
          var item = [];
          item.push(rg.label);
          item.push(rg.value);
          dtSet.push(item);
        });

        this.chartPayments = dtSet;
        this.loading_status = false;
        this.get_docs();
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.loading_status = false;
      }
    },

    calculateKPIs(payments) {
      const kpis = {
        total_ventas: 0,
        total_documentos: new Set(payments.map((p) => p.doc_number)).size,
        total_efectivo: 0,
        total_electronico: 0,
        total_transacciones: payments.length,
      };

      // Calcular totales
      payments.forEach((payment) => {
        const valor = parseFloat(payment.payment_value) || 0;
        kpis.total_ventas += valor;

        // Clasificar por tipo de pago
        if (payment.payment_concept.toLowerCase().includes("efectivo")) {
          kpis.total_efectivo += valor;
        } else {
          kpis.total_electronico += valor;
        }
      });

      // Calcular porcentajes y promedios
      kpis.porcentaje_efectivo =
        kpis.total_ventas > 0
          ? Math.round((kpis.total_efectivo / kpis.total_ventas) * 100)
          : 0;

      kpis.porcentaje_electronico =
        kpis.total_ventas > 0
          ? Math.round((kpis.total_electronico / kpis.total_ventas) * 100)
          : 0;

      kpis.ticket_promedio =
        kpis.total_documentos > 0 ? kpis.total_ventas / kpis.total_documentos : 0;

      this.kpiData = kpis;
    },

    async get_docs() {
      this.loading_status_docs = true;
      var qry = {
        store: window.store.store_id,
        table: "docs",
      };
      qry.filters = [
        {
          field: "doc_type",
          operator: " IN ",
          value: "'invoice','pos','nc'",
        },
        {
          field: "DATE(issuedate)",
          operator: "=",
          value: this.issueDate,
        },
        {
          field: "store",
          operator: "=",
          value: window.store.store_id,
        },
      ];
      if (this.$store.getters.profile.user_access == "USUARIO") {
        qry.filters.push({
          field: "userId",
          operator: "=",
          value: this.$store.state.profile.email,
        });
      }
      console.log(qry);
      let promise = new Promise((resolve, reject) => {
        webserver(
          "get_dataTable",
          qry,
          function (data) {
            resolve(data);
          },
          function () {
            reject([]);
          }
        );
      });
      let data = await promise;
      console.log("=xx===>", data);
      var result = [];
      var dtSet = [];
      dtSet.push(["Forma de pago", "Valor"]);
      dtSet.push(["", 0]);
      data.reduce(function (res, value) {
        if (!res[value.doc_type]) {
          res[value.doc_type] = { label: value.doc_type, qty: 0, value: 0 };
          result.push(res[value.doc_type]);
        }
        res[value.doc_type].qty += 1;
        res[value.doc_type].value += parseFloat(value.doc_value);
        return res;
      }, {});

      result.sort((a, b) => (a.value > b.value ? 1 : b.value > a.value ? -1 : 0));
      //console.log("tipos", result);

      // result.forEach((rg) => {
      //   var item = [];
      //   item.push(rg.label);
      //   item.push(rg.value);
      //   dtSet.push(item);
      // });

      // this.chartPayments = dtSet;

      this.loading_status_docs = false;
      this.cash_data = data;
      //console.log(data);
    },
  },
};
</script>

<style>
.kpi-card {
  transition: all 0.3s;
}

.kpi-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15) !important;
}

.v-data-table >>> th {
  background-color: #f5f5f5 !important;
  font-weight: bold !important;
  white-space: nowrap;
}

.v-data-table >>> tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.02);
}

.secondary {
  background-color: #3949ab !important;
}

/* Mejoras de responsividad */
@media (max-width: 960px) {
  .v-toolbar-title {
    font-size: 1.1rem;
  }
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}
.wrap-text {
  white-space: normal !important; /* Permite múltiples líneas */
  word-break: break-word !important; /* Rompe palabras largas */
  max-width: 200px; /* Opcional: limita el ancho para evitar desbordamiento */
}
</style>
